import { gql } from '@apollo/client';

export const CREATE_CASH_ORDER = gql`
  mutation createCashOrder($input: CashOrderInput!) {
    createCashOrder(input: $input) {
      id
    }
  }
`;
